import type { ReactNode } from "react";

export function DetailRow({
  label,
  value,
  mono,
}: {
  label: string;
  value: ReactNode;
  mono?: boolean;
}) {
  const empty =
    value === null ||
    value === undefined ||
    value === "" ||
    value === "—";
  return (
    <div className="detail-row">
      <dt>{label}</dt>
      <dd className={mono ? "mono" : undefined}>{empty ? "—" : value}</dd>
    </div>
  );
}
